/**
 * Simply Built — Build Your Own Bundle
 * Vanilla JS, no framework, event delegation, no external deps.
 * Reads config from #sb-bundle-config (JSON) rendered by the Liquid section.
 */
(function () {
  'use strict';

  var ROOT_SELECTOR = '.sb-bundle';
  var STORAGE_KEY = 'sb-bundle-state-v1';

  function money(cents, currency) {
    var val = (cents / 100).toFixed(2);
    return '$' + val;
  }

  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function SBBundle(root) {
    this.root = root;
    this.configEl = qs(root, '#sb-bundle-config');
    this.config = this.configEl ? JSON.parse(this.configEl.textContent) : { tiers: [], minItems: 0, ctaTemplate: 'ADD BUNDLE TO CART — {{price}}', currency: 'USD' };
    this.grid = qs(root, '.sb-bundle-grid');
    this.filters = qs(root, '.sb-bundle-filters');
    this.slotsEl = qs(root, '.sb-bundle-slots');
    this.hintEl = qs(root, '.sb-bundle-sidebar__hint');
    this.progressFill = qs(root, '.sb-bundle-progress__fill');
    this.subtotalEl = qs(root, '[data-sb-subtotal]');
    this.savingsRow = qs(root, '[data-sb-savings-row]');
    this.savingsEl = qs(root, '[data-sb-savings]');
    this.savingsLabelEl = qs(root, '[data-sb-savings-label]');
    this.totalEl = qs(root, '[data-sb-total]');
    this.ctaBtn = qs(root, '.sb-bundle-cta');
    this.mobileStatus = qs(root, '[data-sb-mobile-status]');
    this.mobileTilesEl = qs(root, '[data-sb-mobile-tiles]');
    this.mobilePrice = qs(root, '[data-sb-mobile-price]');
    this.viewBundleTriggers = qsa(root, '[data-sb-view-bundle]');
    this.closeDrawerBtn = qs(root, '.sb-bundle-sidebar__close');
    this.backdrop = qs(root, '.sb-bundle-drawer__backdrop');

    // productId -> { id, title, image, category, variants: [{id,title,price,compareAt,available}] }
    this.products = {};
    // productId -> { variantId, qty }
    this.selections = {};
    // productId -> variantId the user has picked via swatch, before adding
    this.pendingVariant = {};

    this.init();
  }

  SBBundle.prototype.init = function () {
    this.indexProducts();
    this.restoreState();
    this.bindEvents();
    this.renderAll();
  };

  SBBundle.prototype.indexProducts = function () {
    var self = this;
    qsa(this.root, '.sb-bundle-card').forEach(function (card) {
      var id = card.getAttribute('data-product-id');
      var variants;
      try { variants = JSON.parse(card.getAttribute('data-variants')); } catch (e) { variants = []; }
      self.products[id] = {
        id: id,
        title: card.getAttribute('data-title'),
        image: card.getAttribute('data-image'),
        category: card.getAttribute('data-category'),
        variants: variants
      };
    });
  };

  SBBundle.prototype.bindEvents = function () {
    var self = this;

    if (this.filters) {
      this.filters.addEventListener('click', function (e) {
        var btn = e.target.closest('.sb-bundle-filter');
        if (!btn) return;
        qsa(self.filters, '.sb-bundle-filter').forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false'); });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        self.applyFilter(btn.getAttribute('data-filter'));
      });
    }

    this.grid.addEventListener('click', function (e) {
      var card = e.target.closest('.sb-bundle-card');
      if (!card) return;
      var id = card.getAttribute('data-product-id');

      var addBtn = e.target.closest('[data-sb-add]');
      if (addBtn) { self.addProduct(id, 1); return; }

      var plus = e.target.closest('[data-sb-plus]');
      if (plus) { self.addProduct(id, 1); return; }

      var minus = e.target.closest('[data-sb-minus]');
      if (minus) { self.addProduct(id, -1); return; }

      var swatch = e.target.closest('[data-sb-variant]');
      if (swatch) { self.setVariant(id, swatch.getAttribute('data-sb-variant')); return; }
    });

    if (this.slotsEl) {
      this.slotsEl.addEventListener('click', function (e) {
        var removeBtn = e.target.closest('[data-sb-remove]');
        if (!removeBtn) return;
        var id = removeBtn.getAttribute('data-sb-remove');
        self.removeProduct(id);
      });
    }

    if (this.ctaBtn) {
      this.ctaBtn.addEventListener('click', function () { self.addBundleToCart(); });
    }

    this.viewBundleTriggers.forEach(function (el) {
      el.addEventListener('click', function () { self.openDrawer(); });
    });
    if (this.closeDrawerBtn) {
      this.closeDrawerBtn.addEventListener('click', function () { self.closeDrawer(); });
    }
    if (this.backdrop) {
      this.backdrop.addEventListener('click', function () { self.closeDrawer(); });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') self.closeDrawer();
    });
  };

  SBBundle.prototype.applyFilter = function (category) {
    qsa(this.grid, '.sb-bundle-card').forEach(function (card) {
      var match = category === 'all' || card.getAttribute('data-category') === category;
      card.style.display = match ? '' : 'none';
    });
  };

  SBBundle.prototype.getVariant = function (productId, variantId) {
    var p = this.products[productId];
    if (!p) return null;
    if (variantId) {
      for (var i = 0; i < p.variants.length; i++) if (p.variants[i].id === variantId) return p.variants[i];
    }
    // default to first available variant
    for (var j = 0; j < p.variants.length; j++) if (p.variants[j].available) return p.variants[j];
    return p.variants[0] || null;
  };

  SBBundle.prototype.addProduct = function (productId, delta) {
    var p = this.products[productId];
    if (!p) return;
    var sel = this.selections[productId];
    var variantId = sel ? sel.variantId : (this.pendingVariant[productId] || (this.getVariant(productId) || {}).id);
    var variant = this.getVariant(productId, variantId);
    if (!variant || !variant.available) return;

    var currentQty = sel ? sel.qty : 0;
    var newQty = Math.max(0, currentQty + delta);

    if (newQty === 0) {
      delete this.selections[productId];
    } else {
      this.selections[productId] = { variantId: variant.id, qty: newQty };
    }

    this.persistState();
    this.renderAll();
  };

  SBBundle.prototype.setVariant = function (productId, variantId) {
    var variant = this.getVariant(productId, variantId);
    if (!variant) return;
    this.pendingVariant[productId] = variant.id;
    var sel = this.selections[productId];
    if (sel) {
      // swap variant, keep quantity, but never exceed new variant's availability assumption
      sel.variantId = variant.id;
    }
    this.renderCard(productId);
    if (sel) { this.persistState(); this.renderSidebar(); }
  };

  SBBundle.prototype.removeProduct = function (productId) {
    delete this.selections[productId];
    this.persistState();
    this.renderAll();
  };

  SBBundle.prototype.getTotals = function () {
    var self = this;
    var subtotalCents = 0;
    var itemCount = 0;
    Object.keys(this.selections).forEach(function (pid) {
      var sel = self.selections[pid];
      var variant = self.getVariant(pid, sel.variantId);
      if (!variant) return;
      subtotalCents += Math.round(parseFloat(variant.price) * 100) * sel.qty;
      itemCount += sel.qty;
    });

    var tier = null;
    for (var i = this.config.tiers.length - 1; i >= 0; i--) {
      if (itemCount >= this.config.tiers[i].qty) { tier = this.config.tiers[i]; break; }
    }

    var discountCents = 0;
    if (tier) {
      if (tier.type === 'percentage') discountCents = Math.round(subtotalCents * (tier.value / 100));
      if (tier.type === 'fixed') discountCents = Math.min(subtotalCents, Math.round(tier.value * 100));
    }

    return {
      itemCount: itemCount,
      subtotalCents: subtotalCents,
      discountCents: discountCents,
      totalCents: Math.max(0, subtotalCents - discountCents),
      activeTier: tier
    };
  };

  SBBundle.prototype.getNextTier = function (itemCount) {
    var tiers = this.config.tiers.slice().sort(function (a, b) { return a.qty - b.qty; });
    for (var i = 0; i < tiers.length; i++) {
      if (itemCount < tiers[i].qty) return tiers[i];
    }
    return null;
  };

  SBBundle.prototype.renderAll = function () {
    var self = this;
    Object.keys(this.products).forEach(function (pid) { self.renderCard(pid); });
    this.renderSidebar();
    this.renderMobileBar();
  };

  SBBundle.prototype.renderCard = function (productId) {
    var card = this.grid.querySelector('.sb-bundle-card[data-product-id="' + productId + '"]');
    if (!card) return;
    var sel = this.selections[productId];
    var activeVariantId = (sel && sel.variantId) || this.pendingVariant[productId];
    var variant = this.getVariant(productId, activeVariantId);

    card.classList.toggle('is-selected', !!sel);

    qsa(card, '[data-sb-variant]').forEach(function (btn) {
      btn.classList.toggle('is-active', variant && btn.getAttribute('data-sb-variant') === variant.id);
    });

    var priceEl = qs(card, '[data-sb-price]');
    if (priceEl && variant) priceEl.textContent = money(Math.round(parseFloat(variant.price) * 100));

    var imgEl = qs(card, '[data-sb-main-image]');
    if (imgEl && variant && variant.image && imgEl.getAttribute('src') !== variant.image) {
      imgEl.setAttribute('src', variant.image);
      imgEl.src = variant.image;
    }

    var descEl = qs(card, '[data-sb-desc]');
    if (descEl && variant) descEl.textContent = variant.title;

    var footer = qs(card, '[data-sb-footer]');
    if (!footer) return;

    if (!sel) {
      footer.innerHTML = '<button type="button" class="sb-bundle-btn" data-sb-add aria-label="Add ' + card.getAttribute('data-title') + ' to bundle">Add to Bundle</button>';
    } else {
      footer.innerHTML =
        '<div class="sb-bundle-qty" role="group" aria-label="Quantity for ' + card.getAttribute('data-title') + '">' +
        '<button type="button" data-sb-minus aria-label="Decrease quantity"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2 7h10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
        '<output>' + sel.qty + '</output>' +
        '<button type="button" data-sb-plus aria-label="Increase quantity"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M7 2v10M2 7h10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
        '</div>';
    }
  };

  SBBundle.prototype.renderSidebar = function () {
    var self = this;
    var totals = this.getTotals();
    var nextTier = this.getNextTier(totals.itemCount);

    // Hint text
    if (this.hintEl) {
      if (nextTier) {
        var remaining = nextTier.qty - totals.itemCount;
        this.hintEl.innerHTML = 'Add ' + remaining + ' more item' + (remaining === 1 ? '' : 's') + ' to unlock <strong>' + nextTier.label + '</strong>';
      } else if (totals.activeTier) {
        this.hintEl.innerHTML = 'You\'ve unlocked <strong>' + totals.activeTier.label + '</strong> — nice work.';
      } else {
        this.hintEl.textContent = 'Add your first piece to start saving.';
      }
    }

    // Progress bar: based on distance to final tier
    if (this.progressFill && this.config.tiers.length) {
      var maxQty = Math.max.apply(null, this.config.tiers.map(function (t) { return t.qty; }));
      var pct = Math.min(100, (totals.itemCount / maxQty) * 100);
      this.progressFill.style.width = pct + '%';
    }

    // Sidebar tiles: product units first, then only still-LOCKED reward
    // tiers get a dedicated cell. Once a tier is unlocked it's "spent" —
    // its cell is handed over to the next product photo instead, so the
    // total number of tiles stays constant as quantity grows (nothing
    // reflows into a new row).
    if (this.slotsEl) {
      var tiers = this.config.tiers.slice().sort(function (a, b) { return a.qty - b.qty; });
      var productUnits = [];

      Object.keys(this.selections).forEach(function (pid) {
        var p = self.products[pid];
        var sel = self.selections[pid];
        if (!p) return;
        var variant = self.getVariant(pid, sel.variantId);
        var variantHtml = (variant && variant.title && variant.title !== 'Default Title')
          ? '<div class="sb-bundle-slot__variant">' + variant.title + '</div>'
          : '';
        for (var u = 0; u < sel.qty; u++) {
          productUnits.push(
            '<div class="sb-bundle-slot">' +
            '<button type="button" class="sb-bundle-slot__remove" data-sb-remove="' + pid + '" aria-label="Remove ' + p.title + '">×</button>' +
            '<img src="' + ((variant && variant.image) || p.image) + '" alt="' + p.title + '" loading="lazy">' +
            '<div class="sb-bundle-slot__name">' + p.title + '</div>' +
            variantHtml +
            '</div>'
          );
        }
      });

      var cells = productUnits.length
        ? productUnits.slice()
        : ['<div class="sb-bundle-slot sb-bundle-slot--empty">' +
           '<span class="sb-bundle-slot__num">1</span>' +
           '<span class="sb-bundle-slot__placeholder">Select Product</span>' +
           '</div>'];

      tiers.forEach(function (t) {
        var unlocked = totals.itemCount >= t.qty;
        if (unlocked) return; // already achieved — cell handed to a product tile instead
        var valueLabel = t.type === 'percentage' ? (t.value + '% OFF') :
          t.type === 'fixed' ? ('$' + t.value + ' OFF') :
          t.type === 'free_shipping' ? 'FREE SHIP' : 'FREE GIFT';
        cells.push(
          '<div class="sb-bundle-reward">' +
          '<div class="sb-bundle-reward__value">' + valueLabel + '</div>' +
          '<div class="sb-bundle-reward__label">Locked at ' + t.qty + '</div>' +
          '</div>'
        );
      });

      this.slotsEl.innerHTML = cells.join('');
    }

    // Summary
    if (this.subtotalEl) this.subtotalEl.textContent = money(totals.subtotalCents);
    if (this.savingsRow) {
      if (totals.discountCents > 0) {
        this.savingsRow.style.display = '';
        if (this.savingsLabelEl && totals.activeTier) {
          this.savingsLabelEl.textContent = totals.activeTier.type === 'percentage' ? ('Total Savings (' + totals.activeTier.value + '%)') : 'Total Savings';
        }
        if (this.savingsEl) this.savingsEl.textContent = '-' + money(totals.discountCents);
      } else {
        this.savingsRow.style.display = 'none';
      }
    }
    if (this.totalEl) this.totalEl.textContent = money(totals.totalCents);

    // CTA
    if (this.ctaBtn) {
      var template = this.config.ctaTemplate || 'ADD BUNDLE TO CART — {{price}}';
      this.ctaBtn.textContent = template.replace('{{price}}', money(totals.totalCents));
      var meetsMin = totals.itemCount >= (this.config.minItems || 0);
      this.ctaBtn.disabled = totals.itemCount === 0 || !meetsMin;
    }

  };

  SBBundle.prototype.renderMobileBar = function () {
    var self = this;
    var totals = this.getTotals();

    if (this.mobileStatus) {
      if (totals.itemCount === 0) {
        this.mobileStatus.textContent = 'Build your bundle';
      } else {
        var label = totals.itemCount + ' item' + (totals.itemCount === 1 ? '' : 's');
        if (totals.activeTier) label += ' · ' + totals.activeTier.label;
        this.mobileStatus.textContent = label;
      }
    }

    if (this.mobileTilesEl) {
      var tiles = [];
      Object.keys(this.selections).forEach(function (pid) {
        var p = self.products[pid];
        var sel = self.selections[pid];
        if (!p) return;
        var variant = self.getVariant(pid, sel.variantId);
        tiles.push('<span class="sb-bundle-mobiletile"><img src="' + ((variant && variant.image) || p.image) + '" alt="" loading="lazy"></span>');
      });

      var tiers = this.config.tiers.slice().sort(function (a, b) { return a.qty - b.qty; });
      tiers.forEach(function (t) {
        var unlocked = totals.itemCount >= t.qty;
        var valueLabel = t.type === 'percentage' ? (t.value + '%') :
          t.type === 'fixed' ? ('$' + t.value) :
          t.type === 'free_shipping' ? 'SHIP' : 'GIFT';
        tiles.push('<span class="sb-bundle-mobiletile sb-bundle-mobiletile--reward' + (unlocked ? ' is-unlocked' : '') + '">' + valueLabel + '</span>');
      });

      this.mobileTilesEl.innerHTML = tiles.join('');
    }

    if (this.mobilePrice) this.mobilePrice.textContent = money(totals.totalCents);
  };

  SBBundle.prototype.openDrawer = function () {
    this.root.setAttribute('data-drawer-open', 'true');
    document.body.style.overflow = 'hidden';
  };

  SBBundle.prototype.closeDrawer = function () {
    this.root.setAttribute('data-drawer-open', 'false');
    document.body.style.overflow = '';
  };

  SBBundle.prototype.persistState = function () {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(this.selections));
    } catch (e) { /* storage unavailable, fail silently */ }
  };

  SBBundle.prototype.restoreState = function () {
    var self = this;
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      var saved = JSON.parse(raw);
      Object.keys(saved).forEach(function (pid) {
        var product = self.products[pid];
        if (!product) return; // product no longer on page
        var variant = self.getVariant(pid, saved[pid].variantId);
        if (!variant || !variant.available) return; // stale/unavailable variant, drop it
        var qty = Math.max(0, parseInt(saved[pid].qty, 10) || 0);
        if (qty > 0) self.selections[pid] = { variantId: variant.id, qty: qty };
      });
    } catch (e) { /* corrupt data, ignore */ }
  };

  SBBundle.prototype.addBundleToCart = function () {
    var self = this;
    var items = Object.keys(this.selections).map(function (pid) {
      var sel = self.selections[pid];
      return { id: sel.variantId, quantity: sel.qty, properties: { '_sb_bundle': 'build-your-own-bundle' } };
    });
    if (!items.length) return;

    this.ctaBtn.disabled = true;
    var originalText = this.ctaBtn.textContent;
    this.ctaBtn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        sessionStorage.removeItem(STORAGE_KEY);
        // Prefer the theme's existing cart drawer if present.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
        var drawerToggle = document.querySelector('[data-cart-drawer-toggle], cart-drawer, #cart-drawer, .cart-drawer');
        if (!drawerToggle) {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        console.error('Simply Built bundle: add to cart failed', err);
        alert('Something went wrong adding your bundle to the cart. Please try again.');
      })
      .finally(function () {
        self.ctaBtn.disabled = false;
        self.renderSidebar();
      });
  };

  function boot() {
    qsa(document, ROOT_SELECTOR).forEach(function (root) {
      if (root.__sbBundleInstance) return;
      root.__sbBundleInstance = new SBBundle(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // The Shopify theme editor reloads section HTML via AJAX whenever a
  // setting changes (adding a product block, editing text, etc). Browsers
  // do not re-execute <script> tags that arrive via that kind of DOM swap,
  // so without this, every edit in the editor silently breaks the section
  // until a full page reload. Re-running boot() here re-attaches behavior
  // to any fresh, not-yet-initialized .sb-bundle root the editor just
  // inserted. Live storefront visitors never trigger this event, so it's
  // a no-op cost for them.
  document.addEventListener('shopify:section:load', boot);
})();